import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import lotteryspinner from "@/assets/lotteryspinner.svg";
import RecentActivities from "@/features/Dashboard/components/recentActivities";
import Logo from "@/assets/tableLogo.svg";
import whitet from "@/assets/white-t.png";
import readme from "@/assets/readme.svg";
import { theme } from "@/components/Elements/theme";
import { useNavigate } from "react-router-dom";
import UpcomingLotteryCrousel from "@/features/Homescreen/Components/upcomingLotteryCrousel";
import UpComingLotteryDraws from "@/features/Homescreen/Components/upcomingLotteryDraws";
import WinningHistory from "@/features/Homescreen/Components/winningHistory";
import { useLotteries } from "../api/getDashboardList";
import Countdown from "react-countdown";
import { any } from "zod";
import comingsoon from "@/assets/coming_soon_logo.png";
import { formatUTCToLocal } from "@/utils/utils";
const useStyles = makeStyles((_theme) => ({
  innerGridFirst: {
    borderRadius: "20px",
    backgroundRepeat: "no-repeat",
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    objectFit: "fill",
    backgroundPosition: "center center",
    [theme.breakpoints.down("md")]: {
      borderRadius: "10px",
    },
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "20px 0px",
    borderRadius: "20px",
    flexGrow: 1,
    [theme.breakpoints.down("md")]: {
      padding: "10px 6px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 0px",
    },
  },
  tableContainer: {
    background: "#050518",
    borderRadius: 8,
  },
  table: {
    minWidth: 650,
  },
  tableHeader: {
    color: "#fff",
  },
  tableData: {
    fontSize: "14px",
    color: "#fff",
    opacity: "0.6",
    borderBottom: "1px solid #0D0D39",
  },
  logo: {
    width: 50,
  },
}));

export const Timer = ({ dataRecent }) => {
  const classes = useStyles();
  let navigate = useNavigate();

  return (
    <>
      {dataRecent?.length ? (
        <Grid container spacing={{ xs: 0.2, sm: 1 }}>
          <Grid item md={5} sm={5} xs={5}>
            <Box
              sx={{
                height: "100%",
                width: "100%",
                position: "relative",
                background: "rgb(75 75 75 / 80%)",
                borderRadius: "10px",
              }}
            >
              <img
                className={classes.innerGridFirst}
                alt="lottery-name"
                src={
                  dataRecent[0]?.image !== undefined
                    ? `${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${dataRecent[0]?.image}`
                    : lotteryspinner
                }
              />
            </Box>
          </Grid>
          <Grid item md={7} sm={7} xs={7}>
            <Box
              className={classes.innerGridSecond}
              sx={{
                height: "100%",
                boxSizing: "border-box",
                textAlign: "center",
              }}
            >
              {Number(dataRecent[0]?.numOfTicketOnSale) -
                Number(dataRecent[0]?.numOfTicketSold) <
              1000 ? (
                <Typography
                  variant="h3"
                  sx={{
                    color: "rgba(255, 255, 255, 0.8)",
                    textAlign: "center",
                    fontSize: {
                      lg: "22px",
                      sm: "16px",
                      xs: "16px",
                    },
                    marginBottom: "10px",
                  }}
                >
                  Available Ticket:{" "}
                  {dataRecent[0]?.numOfTicketOnSale -
                    dataRecent[0]?.numOfTicketSold || 0}
                </Typography>
              ) : (
                ""
              )}
              <Box>
                <Typography
                  component={"h2"}
                  align="center"
                  sx={{
                    textTransform: "uppercase",
                    color: "white",
                    fontSize: {
                      lg: "30px",
                      sm: "20px",
                      xs: "18px",
                    },
                  }}
                >
                  {dataRecent[0]?.lotteryName ? dataRecent[0]?.lotteryName : ""}
                </Typography>
                <Typography
                  variant="caption"
                  align="center"
                  sx={{
                    color: "white",
                    fontSize: {
                      lg: "20px",
                      md: "18px",
                      xs: "16px",
                    },
                    display: "flex",
                    justifyContent: "center",
                    flexFlow: "row wrap",
                    gap: "5px",
                  }}
                >
                  Ticket Price :
                  <Typography
                    component={"span"}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: {
                        lg: "20px",
                        md: "18px",
                        xs: "16px",
                      },
                    }}
                  >
                    <img
                      style={{
                        height: "auto",
                        width: "20px",
                        margin: "0 5px 0 0",
                      }}
                      src={whitet}
                      alt="currency"
                    />
                    {dataRecent[0]?.ticketPrice
                      ? dataRecent[0]?.ticketPrice
                      : " "}
                  </Typography>
                </Typography>
                <Typography
                  variant="h3"
                  align="center"
                  sx={{
                    color: "#FFBC00",
                    mt: "10px",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                    },
                    lineHeight: "1.5",
                    textTransform: "uppercase",
                  }}
                >
                  End date : {formatUTCToLocal(dataRecent[0]?.endDateTime)}
                </Typography>
                <Typography
                  variant="h5"
                  align="center"
                  sx={{
                    fontSize: {
                      lg: "45px !important",
                      md: "35px !important",
                      xs: "25px !important",
                    },
                    fontWeight: "700",
                  }}
                >
                  {dataRecent[0]?.endDate ? (
                    <Countdown
                      date={
                        new Date(
                          `${dataRecent[0]?.endDate}T${dataRecent[0]?.endTime}`
                        )
                      }
                    />
                  ) : (
                    "00:00:00"
                  )}
                </Typography>
              </Box>
              <Box sx={{ mt: "10px" }}>
                {dataRecent[0]?._id ? (
                  <Button
                    sx={{
                      backgroundColor: "#3C37FF",
                      "&:hover": {
                        backgroundColor: "#5853f7",
                      },
                      color: "#FFFF",
                      borderRadius: "19px",
                      padding: "8px 16px",
                      fontSize: {
                        md: "14px",
                        xs: "12px",
                      },
                    }}
                    onClick={() =>
                      navigate(`/app/Lotteries/${dataRecent[0]?._id}`)
                    }
                  >
                    Buy Tickets{" "}
                    <img src={readme} style={{ marginLeft: "10px" }} alt="" />
                  </Button>
                ) : (
                  <Button
                    sx={{
                      backgroundColor: "#3C37FF",
                      "&:hover": {
                        backgroundColor: "#5853f7",
                      },
                      color: "#FFFF",
                      borderRadius: "19px",
                      padding: "8px 16px",
                      fontSize: {
                        md: "14px",
                        xs: "12px",
                      },
                    }}
                  >
                    Buy Tickets{" "}
                    <img src={readme} style={{ marginLeft: "10px" }} alt="" />
                  </Button>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <div
          style={{
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            border: "1px solid",
            textAlign: "center",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <img
            // src={comingsoon}
            src="/Comp_1.gif"
            alt="Coming Soon"
            style={{
              height: "230px",
              width: "220px",
            }}
          />
        </div>
      )}
    </>
  );
};

export default Timer;
